import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import { sync } from 'vuex-router-sync'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import store from './store'
import App from './App.vue'

Vue.config.productionTip = false

/* Vue plugin */
Vue.use(BootstrapVue)
Vue.use(VeeValidate)

const dictionary = {
  en: {
    messages: {
      not_in: (field) => `The ${field} is already existed.`
    }
  }
}

// Override and merge the dictionaries
Validator.localize(dictionary)

/* Sync route to vuex */
sync(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js